import { Component, Vue, Inject } from 'vue-property-decorator';
import Util from '@/lib/util';

@Component
export default class ImportPage extends Vue {
	importPageName: string;
	namespace: string;
	downloadTemplateFile() {
		window.open(this.templateUrl, '_blank');
	}
	get templateUrl() {
		return abp.setting.get(`Template.Import.${this.importPageName}`);
	}
	checkSignalConnected() {
		if (
			Util.isNull(Util.abp.signalr) ||
			Util.isNull(Util.abp.signalr.connect) ||
			Util.isNull(Util.abp.signalr.hubs)
		) {
			return false;
		}
		return true;
	}
	get checkSignalConnectedText() {
		if (this.checkSignalConnected()) return '';
		return Util.L('ConnectSignalrFail');
	}
	resetCountItems() {
		this.$store.commit(`${this.namespace}/setCountItems`, 0);
	}
	resetCountImportedItems() {
		this.$store.commit(`${this.namespace}/setCountImportedItems`, 0);
	}
	resetList() {
		this.$store.commit(`${this.namespace}/resetList`);
	}
	renderErrorMsgElements(errorMessage: string) {
		return Util.renderImportErrorMsgElements(errorMessage);
	}
}
